import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./ViewTopPerformer.module.css";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../labels";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { AxiosInstance } from "../../../../../axios";
function ViewTopTestPerformerAnswerSheet() {
  const location = useLocation();
  const { BatchIDS } = location.state || {};
  let page = R_PER_PAGE;
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [sortOrder, setSortOrder] = useState("");

  // total table data  with pages
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setStudentAnswerData([]);
  };
  useEffect(() => {}, [rowsPerPage, currentPage]);
  const [studentAnswerData, setStudentAnswerData] = useState(null);
  // mobile tooltip
  const totalPages = Math.ceil(studentAnswerData?.length / rowsPerPage);
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const filteredData = studentAnswerData
    ? studentAnswerData.slice(start, end)
    : [];
  let pressTimer;
  document.querySelectorAll(".tooltip-container").forEach((el) => {
    el.addEventListener("touchstart", function () {
      pressTimer = setTimeout(() => {
        this.classList.add("active");
      }, 500); // Long press duration
    });

    el.addEventListener("touchend", function () {
      clearTimeout(pressTimer);
      this.classList.remove("active");
    });
  });

  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = [...studentAnswerData].sort((a, b) => {
      // Convert both strings to lowercase to ensure case-insensitive comparison
      let aValue = a[sortKey]?.toString().toLowerCase();
      let bValue = b[sortKey]?.toString().toLowerCase();

      if (aValue < bValue) {
        return order === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setStudentAnswerData(sortedList);
  };

  useEffect(() => {
    const fetchData = async () => {
      const studentData = {
        medium: "",
        subject: "",
        test_topic: "",
        exam_start_date: "",
        exam_end_date: "",
        upload_start_date: "",
        upload_end_date: "",
        id: BatchIDS ? BatchIDS : "",
      };

      try {
        const response = await AxiosInstance.post(
          "api/test/descriptive/topper_list",
          studentData
        );
        if (response.data?.status === true) {
          setStudentAnswerData(response.data?.data);
        } else {
          setStudentAnswerData([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the function
  }, []);

  return (
    <>
      <div
        className={`${styles.ViewTopTestPerformMain} global_container container-fluid BathHeader`}
      >
        <div className="row">
          <div className=" col-md-6 col-12 ">
            <h2 className="TitleHeader ">Top Performer Answer Sheets</h2>
          </div>

          <div className="col-md-6 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <Link
                  // onClick={() =>
                  //   handleBackFilter(`/DetailViewBatch/${batch_id}/${4}`)
                  // }
                  // to="javascript:void(0)"
                  to={"/TestPerformanceListView"}
                  className="secondaryButton "
                >
                  Back to Test Performance
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="row mx-0">
          <div className="col-md-12 table-responsive tableMinHeight mt-2 px-0">
            <table className={`table`} id="tableListHeader">
              <thead>
                <tr id="th">
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "student_name")}
                    >
                      Name
                    </span>
                    <span
                      className={` textHead_th align-middle material-icons`}
                      onClick={(e) => handleSort(e, "student_name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "over_all_rank")}
                    >
                      Topper's Overall Rank
                    </span>
                    <span
                      className={` textHead_th align-middle material-icons`}
                      onClick={(e) => handleSort(e, "over_all_rank")}
                    >
                      import_export
                    </span>
                  </th>

                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "exam_name")}
                    >
                      Exam Name
                    </span>
                    <span
                      className={` textHead_th align-middle material-icons`}
                      onClick={(e) => handleSort(e, "exam_name")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "subject")}
                    >
                      Subject
                    </span>
                  </th>
                  <th id={`${styles.th}`}>
                    <span
                      className="text_th"
                      onClick={(e) => handleSort(e, "test_topic_name ")}
                    >
                      Test Topic
                    </span>
                  </th>

                  <th id={`${styles.th}`}>
                    {" "}
                    <span className="text_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredData && filteredData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  filteredData?.map((course, index) => (
                    <tr className={styles.rowHover} key={index}>
                      <td id={`${styles.td}`}>{course.student_name}</td>
                      <td id={`${styles.td}`}>{course.over_all_rank}</td>
                      <td title={course.exam_name} id={`${styles.td}`}>
                        {course.exam_name}
                      </td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subject
                            .map((item) => item.subject)
                            .join(", ")}
                        >
                          {course.subject
                            .map((item) => item.subject)
                            .join(", ")}
                        </span>
                      </td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subject
                            .map((item) =>
                              item.test_topics
                                .map((testTopic) => testTopic.test_topic_name)
                                .join(", ")
                            )
                            .join(", ")}
                        >
                          {course.subject
                            .map((item) =>
                              item.test_topics
                                .map((testTopic) => testTopic.test_topic_name)
                                .join(", ")
                            )
                            .join(", ")}
                        </span>
                      </td>
                      <td id={`${styles.td}`}>
                        <a
                          href={`${ImageUrlPrefix}/${course.answer_sheet_path}`}
                          target="_blank"
                          download
                          className={`${styles.button}`}
                        >
                          <span className="material-icons">visibility</span>
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="row mt-2 p-2 ">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              filteredData && filteredData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              filteredData && filteredData?.length > 0
                ? filteredData?.length < currentPage * rowsPerPage
                  ? filteredData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              filteredData && filteredData?.length > 0
                ? filteredData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${styles.prev_buttonTopPerformer} ${styles.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages}
          />
        </div>
      </div>
    </>
  );
}
export default ViewTopTestPerformerAnswerSheet;
